// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"e5426373","173":"e5426373"}[chunkId] + ".chunk.css";
};